import React, { useRef } from "react";
import { Chart, Series, Tooltip, Legend } from "devextreme-react/chart";
import ChartCard from "components/common/pyramid/ChartCard";

const EclGapBySector = ({ data, palette }) => {
  const chartRef = useRef(null);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(value);
  };

  const customizeTooltip = (info) => {
    return {
      html: `
        <div style="padding: 10px;">
          <div style="font-weight: bold; margin-bottom: 5px;">${
            info.argumentText
          }</div>
          <div>ECL Gap : ${formatCurrency(info.value)}</div>
        </div>
      `,
    };
  };

  return (
    <ChartCard title="ECL gap by Sector" chartRef={chartRef} palette={palette}>
      <div className="p-4">
        <Chart
          dataSource={data}
          id="sectorsChart"
          ref={chartRef}
          palette={palette}
        >
          <Series
            name="ECL Gap"
            valueField="value"
            argumentField="name"
            type="bar"
          />

          <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
          <Legend visible={false} />
        </Chart>
      </div>
    </ChartCard>
  );
};

export default EclGapBySector;
